import React, { useState } from "react";
import { ChatSettingsState } from "../../../../../appRedux/reduxInterfaces/ReducersInterfaces";
import { updateRoomName } from "../firebaseCRUD";
import { ChatContextData } from "../../../../../context/ChatContext/ChatContext";
import { useDispatch } from "react-redux";
import { setChatSettings } from "../../../../../appRedux/actions/ChatSettings";
import { findCurrentChatRoom } from "../ChatScripts";
import { useIntl } from "react-intl";

interface ChatChangeRoomNameProps {
   chatSettings: ChatSettingsState;
   chatData: ChatContextData;
   setNewRoomName: (value: string) => void;
}

const ChatChangeRoomName: React.FC<ChatChangeRoomNameProps> = ({
   chatSettings,
   chatData,
   setNewRoomName
}) => {
   const [changeRoomNameMode, setChangeRoomNameMode] = useState<boolean>(false);

   // const [userInput, setUserInput] = useState<string>();

   // const dispatch = useDispatch();

   const intl = useIntl();

   return (
      <div className="room-name">
         <input
            autoFocus
            className="room-name__input"
            placeholder={findCurrentChatRoom(chatData, chatSettings)?.title}
            onChange={(e) => setNewRoomName(e.target.value)}
         />

         {/* {changeRoomNameMode ? (
            <span
               onClick={(e) => handleChangeRoomName(e)}
               style={{ cursor: "pointer" }}
               className="material-symbols-outlined"
            >
               check
            </span>
         ) : (
            <span
               onClick={() => setChangeRoomNameMode(true)}
               style={{ cursor: "pointer" }}
               className="material-symbols-outlined"
            >
               border_color
            </span>
         )} */}
      </div>
   );
};

export default ChatChangeRoomName;
